import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { ELogType } from 'types';

export const getOptions = (
  t: TTranslator<TLocalesKeys>
): Array<{
  title: string;
  value: Array<ELogType> | string;
  sub?: Array<{
    value: ELogType;
    title?: string;
  }>;
}> => [
  {
    title: t('logs.categories.auth'),
    value: 'authorization',
    sub: [
      {
        title: t('log.subcategory.CLIENT_AUTHORIZED_FROM_HOST'),
        value: ELogType.CLIENT_AUTHORIZED_FROM_HOST,
      },
      {
        title: t('log.subcategory.WORKER_AUTHORIZED_FROM_HOST'),
        value: ELogType.WORKER_AUTHORIZED_FROM_HOST,
      },
      {
        title: t('log.subcategory.WORKER_AUTHORIZED_FROM_BILLING'),
        value: ELogType.WORKER_AUTHORIZED_FROM_BILLING,
      },
      {
        title: t('log.user.verified'),
        value: ELogType.USER_VERIFIED,
      },
    ],
  },
  {
    title: t('logs.categories.clients'),
    value: 'client',
    sub: [
      {
        title: t('log.subcategory.USER_REGISTERED'),
        value: ELogType.USER_REGISTERED,
      },
      {
        title: t('log.subcategory.USER_BANNED'),
        value: ELogType.USER_BANNED,
      },
      {
        title: t('log.subcategory.USER_UNBANNED'),
        value: ELogType.USER_UNBANNED,
      },
      {
        title: t('log.subcategory.USER_RESET_PASSWORD'),
        value: ELogType.USER_RESET_PASSWORD,
      },
      {
        title: t('log.subcategory.USER_DISCOUNT_UPDATED'),
        value: ELogType.USER_DISCOUNT_UPDATED,
      },
      {
        title: t('log.subcategory.DEPOSIT_UPDATED'),
        value: ELogType.DEPOSIT_UPDATED,
      },
      {
        title: t('log.subcategory.BONUS_UPDATED'),
        value: ELogType.BONUS_UPDATED,
      },
      {
        title: t('log.subcategory.USER_GROUP_CREATED'),
        value: ELogType.USER_GROUP_CREATED,
      },
      {
        title: t('log.subcategory.USER_GROUP_UPDATED'),
        value: ELogType.USER_GROUP_UPDATED,
      },
      {
        title: t('log.subcategory.USER_GROUP_DELETED'),
        value: ELogType.USER_GROUP_DELETED,
      },
      {
        title: t('log.subcategory.USER_CHANGED_GROUP'),
        value: ELogType.USER_CHANGED_GROUP,
      },
    ],
  },
  {
    title: t('logs.categories.codes'),
    value: 'Коды',
    sub: [
      {
        title: t('log.subcategory.SEND_VERIFY_CODE'),
        value: ELogType.SEND_VERIFY_CODE,
      },
      {
        title: t('log.subcategory.SEND_RESET_CODE'),
        value: ELogType.SEND_RESET_CODE,
      },
    ],
  },
  {
    title: t('logs.categories.workers'),
    value: 'Сотрудники',
    sub: [
      {
        title: t('log.subcategory.WORKER_CREATED'),
        value: ELogType.WORKER_CREATED,
      },
      {
        title: t('log.subcategory.WORKER_UPDATED'),
        value: ELogType.WORKER_UPDATED,
      },
      {
        title: t('log.subcategory.WORKER_DELETED'),
        value: ELogType.WORKER_DELETED,
      },
      {
        title: t('log.subcategory.TASK_ADDED'),
        value: ELogType.TASK_ADDED,
      },
    ],
  },
  {
    title: t('logs.categories.workShifts'),
    value: 'Смены',
    sub: [
      {
        title: t('log.subcategory.WORK_SHIFT_STARTED'),
        value: ELogType.WORK_SHIFT_STARTED,
      },
      {
        title: t('log.subcategory.WORK_SHIFT_FINISHED'),
        value: ELogType.WORK_SHIFT_FINISHED,
      },
    ],
  },
  {
    title: t('logs.categories.hosts'),
    value: 'Оборудование',
    sub: [
      {
        title: t('log.subcategory.HOST_GROUP_CREATED'),
        value: ELogType.HOST_GROUP_CREATED,
      },
      {
        title: t('log.subcategory.HOST_GROUP_DELETED'),
        value: ELogType.HOST_GROUP_DELETED,
      },
      {
        title: t('log.subcategory.HOST_CREATED'),
        value: ELogType.HOST_CREATED,
      },
      {
        title: t('log.subcategory.HOST_SWITCHED_GROUP'),
        value: ELogType.HOST_SWITCHED_GROUP,
      },
      {
        title: t('log.subcategory.HOST_SESSION_STARTED'),
        value: ELogType.HOST_SESSION_STARTED,
      },
      {
        title: t('log.subcategory.HOST_SESSION_FINISHED'),
        value: ELogType.HOST_SESSION_FINISHED,
      },
      {
        title: t('log.subcategory.SEND_HOST_COMMAND'),
        value: ELogType.SEND_HOST_COMMAND,
      },
      {
        title: t('log.subcategory.SHELL_HIGH_ACCESS_ENABLED'),
        value: ELogType.SHELL_HIGH_ACCESS_ENABLED,
      },
      {
        title: t('log.subcategory.SHELL_HIGH_ACCESS_DISABLED'),
        value: ELogType.SHELL_HIGH_ACCESS_DISABLED,
      },
      {
        title: t('log.subcategory.SHELL_DISABLED'),
        value: ELogType.SHELL_DISABLED,
      },
      {
        title: t('log.subcategory.SHELL_ENABLED'),
        value: ELogType.SHELL_ENABLED,
      },
      {
        title: t('logs.host.generate'),
        value: ELogType.HOST_QR_GENERATE,
      },
    ],
  },
  {
    title: t('logs.categories.seances'),
    value: 'Сеансы',
    sub: [
      {
        title: t('log.subcategory.CLIENT_SESSION_STARTED'),
        value: ELogType.CLIENT_SESSION_STARTED,
      },
      {
        title: t('log.subcategory.CLIENT_SESSION_PROLONGED'),
        value: ELogType.CLIENT_SESSION_PROLONGED,
      },
      {
        title: t('log.subcategory.CLIENT_SESSION_FINISHED'),
        value: ELogType.CLIENT_SESSION_FINISHED,
      },
      {
        title: t('log.subcategory.CLIENT_SESSION_HOST_CHANGED'),
        value: ELogType.CLIENT_SESSION_HOST_CHANGED,
      },
      {
        title: t('log.subcategory.HOST_PUNISHED'),
        value: ELogType.HOST_PUNISHED,
      },
      {
        title: t('log.subcategory.CLIENT_SESSION_PAUSED'),
        value: ELogType.CLIENT_SESSION_PAUSED,
      },
      {
        title: t('log.subcategory.CLIENT_SESSION_UNPAUSED'),
        value: ELogType.CLIENT_SESSION_UNPAUSED,
      },
      {
        title: t('log.subcategory.CLIENT_SESSION_UNPAUSED_AUTO'),
        value: ELogType.CLIENT_SESSION_UNPAUSED_AUTO,
      },
    ],
  },
  {
    title: t('logs.categories.sales'),
    value: 'Продажи',
    sub: [
      {
        title: t('log.subcategory.PAYMENT_CREATED'),
        value: ELogType.PAYMENT_CREATED,
      },
      {
        title: t('log.subcategory.PAYMENT_REFUND'),
        value: ELogType.PAYMENT_REFUND,
      },
      {
        title: t('log.subcategory.POST_PAYMENT_CANCELED'),
        value: ELogType.POST_PAYMENT_CANCELED,
      },
    ],
  },
  {
    title: t('category.bonus'),
    value: [ELogType.BONUS_PAYMENT_CREATED],
  },
  {
    title: t('logs.categories.tariffs'),
    value: 'Тарифы',
    sub: [
      {
        title: t('log.subcategory.TARIFF_CREATED'),
        value: ELogType.TARIFF_CREATED,
      },
      {
        title: t('log.subcategory.TARIFF_UPDATED'),
        value: ELogType.TARIFF_UPDATED,
      },
      {
        title: t('log.subcategory.TARIFF_DELETED'),
        value: ELogType.TARIFF_DELETED,
      },
    ],
  },
  {
    title: t('nav.applications'),
    value: 'Приложения',
    sub: [
      {
        title: t('log.subcategory.PROMO_CODE_CREATED'),
        value: ELogType.SHORTCUT_CREATED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_UPDATED'),
        value: ELogType.SHORTCUT_UPDATED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_DELETED'),
        value: ELogType.SHORTCUT_DELETED,
      },
    ],
  },
  {
    title: t('logs.categories.goods'),
    value: 'Товары',
    sub: [
      {
        title: t('log.subcategory.GOOD_CREATED'),
        value: ELogType.GOOD_CREATED,
      },
      {
        title: t('log.subcategory.GOOD_UPDATED'),
        value: ELogType.GOOD_UPDATED,
      },
      {
        title: t('log.subcategory.GOOD_DELETED'),
        value: ELogType.GOOD_DELETED,
      },
      {
        title: t('log.subcategory.WAREHOUSE_GOODS_ADDED'),
        value: ELogType.WAREHOUSE_GOODS_ADDED,
      },
      {
        title: t('log.subcategory.WAREHOUSE_GOODS_DISPOSED'),
        value: ELogType.WAREHOUSE_GOODS_DISPOSED,
      },
      {
        title: t('log.subcategory.GOOD_LOW_STOCK_THRESHOLD_REACHED'),
        value: ELogType.GOOD_LOW_STOCK_THRESHOLD_REACHED,
      },
    ],
  },
  {
    title: t('logs.categories.goods.category'),
    value: 'Группы товаров',
    sub: [
      {
        title: t('log.subcategory.GOOD_CATEGORY_CREATED'),
        value: ELogType.GOOD_CATEGORY_CREATED,
      },
      {
        title: t('log.subcategory.GOOD_CATEGORY_UPDATED'),
        value: ELogType.GOOD_CATEGORY_UPDATED,
      },
      {
        title: t('log.subcategory.GOOD_CATEGORY_DELETED'),
        value: ELogType.GOOD_CATEGORY_DELETED,
      },
    ],
  },
  {
    title: t('logs.categories.services'),
    value: 'Услуги',
    sub: [
      {
        title: t('log.subcategory.SERVICE_CREATED'),
        value: ELogType.SERVICE_CREATED,
      },
      {
        title: t('log.subcategory.SERVICE_UPDATED'),
        value: ELogType.SERVICE_UPDATED,
      },
      {
        title: t('log.subcategory.SERVICE_DELETED'),
        value: ELogType.SERVICE_DELETED,
      },
    ],
  },
  {
    title: t('logs.categories.discounts'),
    value: 'Скидки',
    sub: [
      {
        title: t('log.subcategory.DISCOUNT_CREATED'),
        value: ELogType.DISCOUNT_CREATED,
      },
      {
        title: t('log.subcategory.DISCOUNT_UPDATED'),
        value: ELogType.DISCOUNT_UPDATED,
      },
      {
        title: t('log.subcategory.DISCOUNT_DELETED'),
        value: ELogType.DISCOUNT_DELETED,
      },
    ],
  },
  {
    title: t('logs.categories.promo'),
    value: 'Промокоды',
    sub: [
      {
        title: t('log.subcategory.PROMO_CODE_CREATED'),
        value: ELogType.PROMO_CODE_CREATED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_UPDATED'),
        value: ELogType.PROMO_CODE_UPDATED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_DELETED'),
        value: ELogType.PROMO_CODE_DELETED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_USED'),
        value: ELogType.PROMO_CODE_USED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_EXPIRED'),
        value: ELogType.PROMO_CODE_EXPIRED,
      },
    ],
  },
  {
    title: t('promo.campaign'),
    value: 'Группы промокодов',
    sub: [
      {
        title: t('log.subcategory.PROMO_CODE_CREATED'),
        value: ELogType.PROMO_CAMPAIGN_CREATED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_UPDATED'),
        value: ELogType.PROMO_CAMPAIGN_UPDATED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_DELETED'),
        value: ELogType.PROMO_CAMPAIGN_DELETED,
      },
      {
        title: t('log.subcategory.PROMO_CAMPAIGN_CODES_GENERATED'),
        value: ELogType.PROMO_CAMPAIGN_CODES_GENERATED,
      },
      {
        title: t('log.subcategory.PROMO_CODE_EXPIRED'),
        value: ELogType.PROMO_CAMPAIGN_EXPIRED,
      },
    ],
  },
  {
    title: t('logs.categories.orders'),
    value: [ELogType.CASH_ORDER_CREATED],
  },
  {
    title: t('logs.categories.config'),
    value: 'Конфигурация',
    sub: [
      {
        title: t('log.subcategory.HOST_HARDWARE_CHANGED'),
        value: ELogType.HOST_HARDWARE_CHANGED,
      },
      {
        title: t('log.subcategory.HOST_HARDWARE_APPLIED'),
        value: ELogType.HOST_HARDWARE_APPLIED,
      },
    ],
  },
  {
    title: 'Telegram',
    value: 'Телеграм',
    sub: [
      {
        title: t('log.subcategory.TELEGRAM_LINKED'),
        value: ELogType.TELEGRAM_LINKED,
      },
      {
        title: t('log.subcategory.TELEGRAM_UNLINKED'),
        value: ELogType.TELEGRAM_UNLINKED,
      },
    ],
  },
  {
    title: t('logs.categories.calls'),
    value: 'Вызовы',
    sub: [
      {
        title: t('log.subcategory.HOST_ADMIN_CALLED'),
        value: ELogType.HOST_ADMIN_CALLED,
      },
      {
        title: t('log.subcategory.HOST_ADMIN_CALL_CHECKED'),
        value: ELogType.HOST_ADMIN_CALL_CHECKED,
      },
      {
        title: t('log.subcategory.HOST_ADMIN_CALL_FAILED'),
        value: ELogType.HOST_ADMIN_CALL_FAILED,
      },
    ],
  },
  {
    title: t('logs.categories.reviews'),
    value: [ELogType.CLUB_COMMENT_CREATED],
  },
  {
    title: t('nav.achievements'),
    value: [
      ELogType.ACHIEVEMENT_CREATED,
      ELogType.ACHIEVEMENT_DELETED,
      ELogType.ACHIEVEMENT_ASSIGNED,
    ],
    sub: [
      {
        title: t('log.subcategory.ACHIEVEMENT_CREATED'),
        value: ELogType.ACHIEVEMENT_CREATED,
      },
      {
        title: t('log.subcategory.ACHIEVEMENT_DELETED'),
        value: ELogType.ACHIEVEMENT_DELETED,
      },
      {
        title: t('log.subcategory.ACHIEVEMENT_ASSIGNED'),
        value: ELogType.ACHIEVEMENT_ASSIGNED,
      },
    ],
  },
  {
    title: t('logs.categories.booking'),
    value: 'Бронирование',
    sub: [
      {
        title: t('log.subcategory.BOOKING_CREATED'),
        value: ELogType.BOOKING_CREATED,
      },
      {
        title: t('log.subcategory.BOOKING_CANCELED'),
        value: ELogType.BOOKING_CANCELED,
      },
      {
        title: t('log.subcategory.BOOKING_FAILED_TO_START'),
        value: ELogType.BOOKING_FAILED_TO_START,
      },
      {
        title: t('log.subcategory.BOOKING_UPDATED'),
        value: ELogType.BOOKING_UPDATED,
      },
      {
        title: t('log.subcategory.BOOKING_CONFIRMED'),
        value: ELogType.BOOKING_CONFIRMED,
      },
    ],
  },
  {
    title: t('logs.categories.combos'),
    value: 'Комбо',
    sub: [
      {
        title: t('log.subcategory.COMBO_CREATED'),
        value: ELogType.COMBO_CREATED,
      },
      {
        title: t('log.subcategory.COMBO_UPDATED'),
        value: ELogType.COMBO_UPDATED,
      },
      {
        title: t('log.subcategory.COMBO_DELETED'),
        value: ELogType.COMBO_DELETED,
      },
    ],
  },
  {
    title: t('logs.categories.onlineDeposit'),
    value: [ELogType.DEPOSIT_ADDED_ONLINE],
  },
  {
    title: t('logs.categories.management'),
    value: [
      ELogType.DEBT_ACTIVATED,
      ELogType.SETTINGS_UPDATED,
      ELogType.SETTINGS_COPIED,
    ],
  },
  {
    title: t('reports.table.transfers'),
    value: [ELogType.USER_DEPOSIT_TRANSFERRED],
  },
  {
    title: t('nav.news'),
    value: [
      ELogType.NEWS_CREATED,
      ELogType.NEWS_UPDATED,
      ELogType.NEWS_DELETED,
    ],
  },
  {
    title: t('nav.advertisement'),
    value: 'обьявления',
    sub: [
      {
        title: t('advertisement.select.completed'),
        value: ELogType.ADVERTISEMENT_MANUAL_COMPLETED,
      },
      {
        title: t('advertisement.select.rejected'),
        value: ELogType.ADVERTISEMENT_REJECTED,
      },
      {
        title: t('advertisement.select.moderation'),
        value: ELogType.ADVERTISEMENT_MODERATION,
      },
      {
        title: t('advertisement.select.approved'),
        value: ELogType.ADVERTISEMENT_APPROVED,
      },
    ],
  },
];
